import React from 'react';
import { Popover } from 'antd';
import type { DisplayGroup, GroupResource } from '../../constants';
import styles from './groupInfoPopover.module.scss';

interface GroupInfoPopoverProps {
  group: DisplayGroup;
  children: React.ReactNode;
}

interface ResourceItemProps {
  resource: GroupResource;
  icon: string;
}

interface ResourceListProps {
  label: string;
  emptyMessage: string;
  items: GroupResource[];
  icon: string;
}

const openResource = (url: string) => {
  window.open(url, '_blank', 'noopener,noreferrer');
};

const ResourceItem: React.FC<ResourceItemProps> = ({ resource, icon }) => {
  const handleClick = () => {
    openResource(resource.url);
  };

  return (
    <li>
      <button type="button" className={styles.resource} onClick={handleClick}>
        <img className={styles.resourceIcon} src={icon} alt="" aria-hidden="true" />
        <span className={styles.resourceName}>{resource.name}</span>
        <img className={styles.linkIcon} src="/assets/externalNavigationIcon.svg" alt="" aria-hidden="true" />
      </button>
    </li>
  );
};

const ResourceList: React.FC<ResourceListProps> = ({ label, emptyMessage, items, icon }) => (
  <div className={styles.group}>
    <p className={styles.groupLabel}>{label}</p>
    {items.length > 0 ? (
      <ul className={styles.resourceList}>
        {items.map((item) => (
          <ResourceItem key={item.name} resource={item} icon={icon} />
        ))}
      </ul>
    ) : (
      <p className={styles.emptyMessage}>{emptyMessage}</p>
    )}
  </div>
);

const GroupInfoPopover: React.FC<GroupInfoPopoverProps> = ({ group, children }) => {
  const content = (
    <div className={styles.content}>
      <p className={styles.header}>{group.name}</p>
      <div className={styles.body}>
        <ResourceList label="Maps" emptyMessage="No maps assigned to this group." items={group.maps} icon="/assets/mapIcon.svg" />
        <ResourceList label="Files" emptyMessage="No files assigned to this group." items={group.files} icon="/assets/fileIcon.svg" />
      </div>
    </div>
  );

  return (
    <Popover content={content} trigger="hover" placement="rightTop" arrow={false} overlayClassName={styles.popover}>
      <span>{children}</span>
    </Popover>
  );
};

export default GroupInfoPopover;
